module.exports = __webpack_public_path__ + "img/BC_FOR_H_RGB_pos.cd8b6ec2.png";